import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';

@Component({
  selector: 'app-uom',
  templateUrl: './uom.component.html',
  styleUrls: ['./uom.component.css']
})
export class UOMComponent implements OnInit {

  constructor(private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 
UOMModel = {
    UOMID: 0,
    UOM: '',
    IsActive: true
}

Clear  () {

    this.UOMModel.UOMID = 0;
    this.UOMModel.UOM = '';
    this.UOMModel.IsActive = true;
    this.Submitted = false;
}
AlertCategory = '';
UOMList:any;
Submitted = false;
SaveUOM  (valid) {
    this.Submitted = true;
    this.AlertCategory = '';
    for (var i = 0; i < this.UOMList.length; i++) {

        if (this.UOMList[i].UOM == this.UOMModel.UOM && this.UOMList[i].UOMID != this.UOMModel.UOMID) {

            this.AlertCategory = ' UOM Already Exists ';
            return false
        }
    }
    if (valid) {
        this.spinnerService.show();
        
        this.stockService.SaveUOM(JSON.stringify(this.UOMModel)).subscribe( (response)=> {
           
                 this.spinnerService.hide();
                
           
            this.Clear();
            this.GetAllUOM();
            this.globalHelper.CheckActionStatus(response);
        });
    }
};

GetAllUOM  () {
    this.spinnerService.show();
    this.stockService.GetAllUOM().subscribe( (response)=> {
        this.UOMList = response.UOMList;
         this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);

    });
};

Edit  (obj) {
    this.UOMModel.UOMID = obj.UOMID;
    this.UOMModel.UOM = obj.UOM;
    this.UOMModel.IsActive = obj.IsActive;
};
GetStatus  (IsActive) {
    return IsActive ? 'Yes' : 'No';
};


  ngOnInit() {
    this.GetAllUOM();
  }

}
